<script lang="ts">
	interface Props {
		question: string;
		answer: string;
		itemIndex?: number; // For accessibility IDs
		defaultOpen?: boolean;
	}

	let { question, answer, itemIndex = 0, defaultOpen = false }: Props = $props();

	let isOpen = $state(false);

	// Initialize and respond to prop changes
	$effect(() => {
		isOpen = defaultOpen;
	});

	function toggle() {
		isOpen = !isOpen;
	}
</script>

<div class="bg-linear-card rounded-lg border border-ak-border-subtle overflow-hidden">
	<button
		type="button"
		onclick={toggle}
		class="w-full flex items-center justify-between p-4 min-h-12 text-left hover:bg-ak-deep/30 active:bg-ak-deep/50 transition-colors cursor-pointer touch-manipulation"
		aria-expanded={isOpen}
		aria-controls="faq-answer-{itemIndex}"
	>
		<span class="font-semibold pr-4">{question}</span>
		<svg
			class="w-5 h-5 text-ak-wintergreen shrink-0 transition-transform {isOpen ? 'rotate-180' : ''}"
			fill="none"
			viewBox="0 0 24 24"
			stroke="currentColor"
			stroke-width="2"
		>
			<path stroke-linecap="round" stroke-linejoin="round" d="M19 9l-7 7-7-7" />
		</svg>
	</button>
	{#if isOpen}
		<div id="faq-answer-{itemIndex}" role="region" class="px-4 pb-4 pt-0">
			<p class="text-ak-text-secondary leading-relaxed">{@html answer}</p>
		</div>
	{/if}
</div>
